import { render, staticRenderFns } from "./public-booking-request-view-modal.vue?vue&type=template&id=643b4634&scoped=true&"
import script from "./public-booking-request-view-modal.vue?vue&type=script&lang=ts&"
export * from "./public-booking-request-view-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b4634",
  null
  
)

export default component.exports